export default (name: string): string | null => {
  const meta = document.querySelector(`meta[name="${name}"]`)
  const content = meta && meta.getAttribute("content")
  return content
}
